<tt-page>
    <tt-card class="col-xs-12 col-md-3 sp-0">
        <tt-button ttText="update_webshop" (ttClick)="updateWebShop()" [ttSpin]="updatingWebShop" ttIcon="fas fa-sync"></tt-button>
    </tt-card>
</tt-page>
